import { FC, Fragment } from 'react'
import { Box, useTheme } from '@mui/material'
import { ToggleSwitch } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'
import { StartDateControl } from './StartDateControl'
import { EndDateControl } from './EndDateControl'

export interface TimeConstrainedControlProps {
    selectedStartDate: any
    setSelectedStartDate: any
    selectedEndDate: any
    setSelectedEndDate: any
    isEndDateDisabled?: any
    maxEndDate?: any
    hasInvalidDates: any
    validationMessage: any
    toggle?: boolean
    setToggle?: any
    disabled: boolean
    hideSwitch: boolean
    hideStartDate?: boolean
}

export const TimeConstrainedControl: FC<TimeConstrainedControlProps> = ({
    selectedStartDate,
    setSelectedStartDate,
    selectedEndDate,
    setSelectedEndDate,
    isEndDateDisabled,
    maxEndDate,
    hasInvalidDates,
    validationMessage,
    toggle,
    disabled,
    setToggle,
    hideSwitch,
    hideStartDate = false,
}) => {
    const { t } = useTranslation()
    const theme = useTheme()

    return (
        <>
            {!hideSwitch && (
                <Box>
                    <ToggleSwitch
                        value={toggle}
                        label={t('Common_SetDuration')}
                        labelColor="#5d6870"
                        disabled={disabled}
                        onChange={() => setToggle((prev: any) => !prev)}
                    />
                </Box>
            )}

            {toggle && (
                <Box display={'flex'}>
                    <Fragment>
                        {!hideStartDate && (
                            <Box
                                sx={{
                                    marginLeft: '16px',
                                    width: '157px',

                                    '@media (max-width:959px)': {
                                        width: '100%',
                                        marginLeft: '0px',
                                        paddingTop: '8px',
                                        paddingBottom: '8px',
                                    },
                                }}
                            >
                                <StartDateControl
                                    selectedStartDate={selectedStartDate}
                                    setSelectedStartDate={setSelectedStartDate}
                                    disabled={disabled}
                                />
                            </Box>
                        )}
                        <Box
                            sx={{
                                marginLeft: '24px',
                                width: '157px',

                                '@media (max-width:959px)': {
                                    width: '100%',
                                    marginLeft: '0px',
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                },
                            }}
                        >
                            <EndDateControl
                                selectedStartDate={selectedStartDate}
                                selectedEndDate={selectedEndDate}
                                setSelectedEndDate={setSelectedEndDate}
                                maxEndDate={maxEndDate}
                                hasInvalidDates={hasInvalidDates}
                                disabled={disabled || isEndDateDisabled}
                            />
                            {hasInvalidDates && validationMessage && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        fontSize: '12px',
                                        color: theme?.palette?.error?.main,
                                        marginRight: '12px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {validationMessage}
                                </Box>
                            )}
                        </Box>
                    </Fragment>
                </Box>
            )}
        </>
    )
}
